import type { EntityConfig } from '../types'

export const paymentLinkEntity: EntityConfig = {
  id: 'payment-link',
  displayName: 'Payment Link',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'draft', label: 'Drafts' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'blocked', label: 'Blocked' },
      { value: 'expired', label: 'Expired' }
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'draft', label: 'Draft', color: 'warning' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'blocked', label: 'Blocked', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'error' }
    ],
    mappings: {
      all: ['active', 'inactive', 'blocked', 'draft', 'expired'],
      active: ['active'],
      draft: ['draft'],
      inactive: ['inactive'],
      blocked: ['blocked'],
      expired: ['expired']
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    type: { type: 'string_array', urlKey: 'type' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    expiredDate: { type: 'date_range', urlKey: 'expiredDate' },
    lastUsedDate: { type: 'date_range', urlKey: 'lastUsedDate' },
    blockedDate: { type: 'date_range', urlKey: 'blockedDate' },
    lastUpdatedDate: { type: 'date_range', urlKey: 'lastUpdatedDate' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'status',
    'type',
    'createdDate',
    'expiredDate',
    'lastUsedDate',
    'blockedDate',
    'lastUpdatedDate',
  ]
}
